import { render, staticRenderFns } from "./ModalDeleteComment.vue?vue&type=template&id=b0ca6300"
import script from "./ModalDeleteComment.vue?vue&type=script&lang=js"
export * from "./ModalDeleteComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports